import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../../components/style.css';
import axios from 'axios';

function ForgetPassword() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [serverOtp, setServerOtp] = useState('');
  const [sentOtp, setSentOtp] = useState(null);
  const [showEnterOtp, setShowEnterOtp] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [verificationStatus, setVerificationStatus] = useState('');
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const navigate = useNavigate();

  const generateRandomCode = () => {
    return Math.floor(100000 + Math.random() * 900000); // Generate a 6-digit random number
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    // Check if the mobile number is registered in the database
    try {
      const userResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`);
      const userData = await userResponse.json();
  
      if (!userResponse.ok || !userData) {
        setErrorMessage(language === "English" ? 'We\'re sorry. You have not registered yet please register first we weren\'t able to identify you.' : 'आपल्याला दिलेल्या मोबाईल नंबरद्वारे आपली ओळख करण्यात आलेली नाही. कृपया आधी नोंदणी करा.');
        return;
      }
  
      const otp = generateRandomCode();
      setSentOtp(otp);
      setShowEnterOtp(true);
  
      // Send OTP via SMS
      const message = `Your Verification Code is ${otp}. - Expertskill Technology.`;
      const accusage = "1";
      const encodedMessage = encodeURIComponent(message);

      const username = "Experts";
      const authkey = "ba9dcdcdfcXX";
      const mobiles = "+91" + mobileNumber.trim();
      const senderId = "EXTSKL";

    
      const mainUrl = "https://mobicomm.dove-sms.com/submitsms.jsp?";
      const url = `${mainUrl}user=${username}&key=${authkey}&mobile=${mobiles}&message=${encodedMessage}&accusage=${accusage}&senderid=${senderId}`;
  
      // Make API call to send OTP
      axios.post(url)
        .then(response => {
          setErrorMessage('');
        })
        .catch(error => {
          console.error('Error sending OTP:', error);
          setErrorMessage(language === "English" ? 'An error occurred while sending OTP. Please try again.' : 'OTP पाठवताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.');
        });
    } catch (error) {
      console.error('Error sending OTP:', error);
      setErrorMessage(language === "English" ? 'An error occurred while sending OTP. Please try again.' : 'OTP पाठवताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.');
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (serverOtp.trim() === sentOtp.toString()) {
      setVerificationStatus(language === "English" ? "Your OTP Verified Successfully." : "आपला OTP यशस्वीरित्या सत्यापित झाला आहे.");
      setErrorMessage('');
    } else {
      setVerificationStatus(language === "English" ? "OTP did not match." : "OTP जुळला नाही.");
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    // Update password in the database
    try {
      const userResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`);
      const userData = await userResponse.json();

      if (!userResponse.ok || !userData) {
        setErrorMessage(language === "English" ? 'Mobile number is not registered.' : 'मोबाईल नंबर नोंदणीकृत नाही.');
        return;
      }

      // Update password
      await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`, {
        method: 'PATCH',
        body: JSON.stringify({ password: newPassword }),
      });

      setErrorMessage('');
      setVerificationStatus (language === "English" ? "Password changed successfully!" : "पासवर्ड यशस्वीरित्या बदलला!");
      setNewPassword('');
      setMobileNumber('');
      setShowEnterOtp(false);
    } catch (error) {
      console.error('Error changing password:', error);
      setErrorMessage(language === "English" ? 'An error occurred while changing the password. Please try again.' : 'पासवर्ड बदलताना त्रुटी आली. कृपया नंतर पुन्हा प्रयत्न करा.');
    }
  };


  // CSS styles
  const containerStyle = {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    overflow: 'auto',
    padding: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      padding: '1rem'
    }
  };

  const formCardStyle = {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    padding: '2rem',
    maxWidth: '600px',
    width: '100%',
    transform: 'translateY(0)',
    transition: 'all 0.3s ease',
    animation: 'fadeIn 0.5s ease-out',
    margin: '0 auto'
  };

  const formRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '1rem -1rem',
    alignItems: 'center'
  };

  const formColumnStyle = {
    flex: '2',
    minWidth: '300px',
    padding: '1rem',
    '@media (max-width: 768px)': {
      minWidth: '100%'
    }
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: 'red',
    marginBottom: '2rem',
    textAlign: 'center',
    animation: 'slideDown 0.5s ease-out'
  };

  const inputContainerStyle = {
    marginBottom: '1.5rem'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    color: '#374151',
    fontWeight: '500'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem 1rem',
    borderRadius: '10px',
    border: '2px solid #e5e7eb',
    transition: 'all 0.3s ease',
    fontSize: '1rem',
    outline: 'none'
  };

  const buttonStyle = {
    width: '100%',
    padding: '0.75rem 1.5rem',
    borderRadius: '10px',
    backgroundColor: '#4f46e5',
    color: 'white',
    border: 'none',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '1rem',
    transform: 'translateY(0)',
    boxShadow: '0 4px 6px rgba(79, 70, 229, 0.2)'
  };

  const errorStyle = {
    color: '#ef4444',
    marginTop: '0.5rem',
    fontSize: '0.875rem',
    animation: 'shake 0.5s ease-in-out'
  };


  
  return (
    <div style={containerStyle}>
      <div style={formCardStyle} className="form-card">
        <h1 style={titleStyle}>{language === 'English' ? 'Forget Password' : 'पासवर्ड विसरला'}</h1>

        <div style={formRowStyle} className="form-row">
          <div style={formColumnStyle} className="form-column">
            <form>
            
              <div style={inputContainerStyle}>
                <p>{language === 'English' ? 'Enter the mobile phone number associated with your Digital School Software account.' : 'आपल्या डिजिटल स्कूल सॉफ्टवेअर खात्याशी संबंधित मोबाईल फोन नंबर प्रविष्ट करा.'}</p>
                <label style={labelStyle} htmlFor="mobileNumber">
                  {language === 'English' ? 'Mobile Number:' : 'मोबाईल नंबर:'}
                </label>
                <input
                  style={inputStyle}
                  maxLength={10}
                  type="text"
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={e => setMobileNumber(e.target.value)}
                />
              </div>

              {/* Send OTP Button */}
              {!showEnterOtp && (
                <button
                  style={buttonStyle}
                  onClick={handleSendOtp}
                  disabled={mobileNumber.length !== 10}
                >
                  {language === 'English' ? 'Send OTP' : 'OTP पाठवा'}
                </button>
              )}

              {/* Error Message for Unregistered Mobile Number */}
              {errorMessage && (
                <div style={errorStyle}>{errorMessage}</div>
              )}

              {/* OTP Verification */}
              {showEnterOtp && (
                <div>
                  <div style={inputContainerStyle}>
                    <p>{language === 'English' ? 'Enter verification code. For your security, we have sent the code to your phone.' : 'सत्यापन कोड प्रविष्ट करा. आपल्या सुरक्षेसाठी, आम्ही कोड आपल्या फोनवर पाठविला आहे.'}</p>
                    <label style={labelStyle} htmlFor="otp">
                      {language === 'English' ? 'Enter OTP:' : 'OTP टाका:'}
                    </label>
                    <input
                      style={inputStyle}
                      type="text"
                      id="otp"
                      value={serverOtp}
                      onChange={e => setServerOtp(e.target.value)}
                    />
                  </div>
                  <button
                    style={buttonStyle}
                    onClick={handleVerifyOtp}
                  >
                    {language === 'English' ? 'Verify OTP' : 'OTP सत्यापित करा'}
                  </button>
                </div>
              )}

              {/* Password Change */}
              {verificationStatus && (
                <div style={errorStyle}>{verificationStatus}</div>
              )}

              {verificationStatus === 'Your OTP Verified Successfully.' && (
                <div>
                  <div style={inputContainerStyle}>
                    <label style={labelStyle} htmlFor="newPassword">
                      {language === 'English' ? 'New Password:' : 'नवीन पासवर्ड:'}
                    </label>
                    <input
                      style={inputStyle}
                      type="password"
                      id="newPassword"
                      value={newPassword}
                      onChange={e => setNewPassword(e.target.value)}
                    />
                  </div>
                  <button
                    style={buttonStyle}
                    onClick={handleChangePassword}
                  >
                    {language === 'English' ? 'Change Password' : 'पासवर्ड बदला'}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;